import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from 'react-intl';

class ChargeSummary extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {charges, style, type} = this.props;

        if (!charges || !charges.get('details') || charges.get('details').count() === 0) {
            return null;
        }

        let recurringChargeTotal = 0;
        let oneTimeChargeTotal = 0;

        charges
            .get('details')
            .forEach((item) => {
                if (item.get('chargeType') === 'R') {
                    recurringChargeTotal += item.get('quantity') * item.get('cost');
                }

                if (item.get('chargeType') === 'O') {
                    oneTimeChargeTotal += item.get('quantity') * item.get('cost');
                }
            });

        let labelStyle = {},
            br = null;

        if (type === 'verticle') {
            br = (<br/>);
        } else {
            labelStyle = {
                paddingLeft: '8px'
            };
        }

        return (
            <span style={style}>
                <label>One Time Total:</label>
                <FormattedNumber value={oneTimeChargeTotal} style="currency" currency="USD"/> {br}
                <label style={labelStyle}>Recurring Total:</label>
                <FormattedNumber value={recurringChargeTotal} style="currency" currency="USD"/>

            </span>
        );
    }
}

ChargeSummary.propTypes = {
    charges: PropTypes.object,
    style: PropTypes.object,
    type: PropTypes.string
};
export default ChargeSummary;



// WEBPACK FOOTER //
// ./src/components/charges/ChargeSummary.js